import * as React from 'react';
import { HtmlTemplate } from './HtmlTemplate';
import HtmlTemplateView from './HtmlTemplateView';
import { Button, Modal } from 'antd';
import EmailEditor from 'react-email-editor';
import './HtmlTemplateStyle.less';

export interface TemplateInputProps {
  value?: HtmlTemplate;
  onChange?: (value?: HtmlTemplate) => void;
  editorProps?: any;
}

interface HtmlTemplateInputState {
  editing: boolean;
  saving: boolean;
}

export default class HtmlTemplateInput extends React.Component<
  TemplateInputProps,
  HtmlTemplateInputState
> {
  state: HtmlTemplateInputState = {
    editing: false,
    saving: false,
  };

  onSave = () => {
    const { onChange } = this.props;
    if (this.designer !== undefined && this.designer !== null && this.editorLoaded && onChange) {
      this.setState({ saving: true });
      this.designer.exportHtml((data: any) => {
        onChange({ design: JSON.stringify(data.design), html: data.html });
        this.setState({ saving: false, editing: false });
      });
    }
  };

  designer?: EmailEditor;
  editorLoaded = false;

  onEditorLoad = () => {
    if (
      this.designer !== undefined &&
      this.designer !== null &&
      this.editorLoaded &&
      this.props.value
    ) {
      this.designer.loadDesign(JSON.parse(this.props.value.design));
    }
  };

  render(): React.ReactNode {
    const { value, editorProps } = this.props;
    return (
      <div className={'template-editor'} style={{ padding: 0, minHeight: 100, height: 'auto' }}>
        {value !== undefined && <HtmlTemplateView value={value.html} />}
        <Button
          className="template-editor-overlay"
          type="ghost"
          onClick={() => this.setState({ editing: true })}>
          {' '}
        </Button>
        <Modal
          title={'Template'}
          open={this.state.editing}
          onOk={this.onSave}
          onCancel={() => this.setState({ editing: false })}
          okText="Save"
          confirmLoading={this.state.saving}
          cancelText="Cancel"
          destroyOnClose={true}
          // maskClosable={this.props.maskClosable}
          closable={true}
          width={'96%'}
          style={{ maxWidth: '96%' }}>
          <EmailEditor
            style={{ width: '100%', minHeight: 'calc(100vh - 300px)' }}
            ref={(designer: any) => {
              this.designer = designer;
              this.onEditorLoad();
            }}
            projectId={3657}
            onLoad={() => {
              this.editorLoaded = true;
              this.onEditorLoad();
            }}
            {...editorProps}
          />
        </Modal>
      </div>
    );
  }
}
